import type { CustomFieldAttribute, LedgerType } from '@libs/enums';
import {
  Bool,
  Characters,
  ItemName,
  Locale,
  Numeric,
  SingleValue,
  WithExclusion,
  type WithExclusionObject,
} from '@ps-smart-cp/ppfw-client';

interface Schema {
  /**
   * カスタムフィールドキー
   */
  customFieldKey: number;
  /**
   * カスタムフィールドの入力値
   */
  customFieldValue: string;
  /**
   * カスタムマスタコード(抽出条件)
   */
  customMstCodeRange: WithExclusionObject;
  /**
   * 属性
   */
  attribute: CustomFieldAttribute;
  /*
   * 台帳
   */
  ledger: LedgerType;
  /**
   * 表示順
   */
  displayOrder: number;
  /**
   * カスタムフィールド(表示用)
   */
  customField: string;
  /**
   * 入力必須
   */
  isRequired: boolean;
  /**
   * カスタムフィールド(抽出条件)
   */
  customFieldCondition: WithExclusionObject;
  /**
   * カスタムフィールド名称
   */
  customFieldName: string;
}

interface R {
  customFieldKey: number;
  customFieldValue: string;
  customMstCodeRange: string;
  isCustomMstCodeRangeExcluded: boolean;
  customField: string;
  customFieldRange: string;
  isCustomFieldRangeExclusion: boolean;
  customFieldName: string;
  customFieldCodes: Record<string, string>;
  ledger: string;
  displayOrder: number;
  isRequired: boolean;
}

const attributes = {
  customFieldCondition: WithExclusion.of(Characters.preset.halfWidth()),
  attribute: SingleValue.shortValue(),
  displayOrder: Numeric.of(1, 30, 0, true),
  customField: SingleValue.shortValue(),
  isRequired: Bool.new(),
};

const names = {
  customFieldBasicInfo: ItemName.of([Locale.ja, 'カスタムフィールド基本情報']),
  customFieldLedgerConnectionInfo: ItemName.of([Locale.ja, 'カスタムフィールド台帳連携情報']),
  attribute: ItemName.of([Locale.ja, '属性']),
  displayOrder: ItemName.of([Locale.ja, '表示順']),
  customField: ItemName.of([Locale.ja, 'カスタムフィールド']),
  isRequired: ItemName.of([Locale.ja, '入力必須']),
  customField01: ItemName.of([Locale.ja, 'カスタムフィールド01']),
  customField02: ItemName.of([Locale.ja, 'カスタムフィールド02']),
  customField03: ItemName.of([Locale.ja, 'カスタムフィールド03']),
  customField04: ItemName.of([Locale.ja, 'カスタムフィールド04']),
  customField05: ItemName.of([Locale.ja, 'カスタムフィールド05']),
};

const titleNames = {
  basicInfoSetting: ItemName.of([Locale.ja, 'カスタムフィールド設定-基本情報設定']),
  ledgerConnectionSetting: ItemName.of([Locale.ja, 'カスタムフィールド設定-台帳連携設定']),
};

const buttonNames = {
  toBasicInfoSetting: ItemName.of([Locale.ja, '基本情報設定へ']),
  toLedgerConnectionSetting: ItemName.of([Locale.ja, '台帳連携設定へ']),
};

const customField = {
  buttonNames,
  titleNames,
  names,
  attributes,
};

interface CustomField {
  schema: Schema;
  record: R;
}

export { customField };
export type { CustomField };
